import { SiteFooter } from "./SiteFooter";
import "./home-v5.css";
import { RAYK_PORTRAIT_PATH, RAYK_PORTRAIT_PNG_PATH } from "./lib/portrait";

/**
 * Fallback homepage for hosts that aren't one of the recognized booking
 * domains (local dev, previews, or a domain not yet wired into
 * lib/bookingHost.ts). On the real domains, App.tsx redirects the root
 * path straight into booking or events before this ever renders.
 */
export function BookingLandingHeroV5() {
  return (
    <main className="home-v5" aria-labelledby="home-v5-title">
      <span className="home-v5__paint home-v5__paint--pink" aria-hidden="true" />
      <span className="home-v5__paint home-v5__paint--blue" aria-hidden="true" />
      <span className="home-v5__paint home-v5__paint--lime" aria-hidden="true" />

      <div className="home-v5__canvas">
        <header className="home-v5__header">
          <a className="home-v5__brand" href="/" aria-label="Rayk Schörling Startseite">
            Rayk Schörling
          </a>
          <p className="home-v5__strap">1:1 · Aufstellungen · Teachings</p>
        </header>

        <section className="home-v5__hero">
          <div className="home-v5__content">
            <div className="home-v5__title">
              <h1 id="home-v5-title">Hier geht es nicht nur um Lösungen.</h1>
            </div>

            <div className="home-v5__life">
              <p>Hier geht es um Leben.</p>
              <div className="home-v5__intro">
                <strong>Wenn du merkst, dass Denken allein nicht mehr weiterführt.</strong>
                <span>
                  In Beziehung, Familie, Führung oder einer Entscheidung. Wir müssen nicht
                  vorschnell festlegen, was richtig ist. Wir halten, was gleichzeitig da ist, bis
                  sichtbar wird, was jetzt Bewegung braucht.
                </span>
              </div>
            </div>

            <nav className="home-v5__actions" aria-label="Bereiche">
              <a className="home-v5__action home-v5__action--primary" href="/termine">
                <span>1:1 Termin · online oder Berlin</span>
                <span aria-hidden="true">→</span>
              </a>
              <a className="home-v5__action" href="/veranstaltungen">
                <span>Aufstellungen & Veranstaltungen</span>
                <span aria-hidden="true">→</span>
              </a>
            </nav>
          </div>

          <figure className="home-v5__portrait" aria-label="Rayk Schörling">
            <picture>
              <source type="image/webp" srcSet={RAYK_PORTRAIT_PATH} />
              <img
                src={RAYK_PORTRAIT_PNG_PATH}
                alt="Rayk Schörling"
                fetchPriority="high"
                decoding="async"
              />
            </picture>
          </figure>
        </section>
      </div>
      <SiteFooter />
    </main>
  );
}
